import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { DocumentTableComponent } from '../../../../shared/document-table-component/document-table-component';
import { Document } from '../../../../shared/document-directive';

@Component({
  selector: 'app-processed',
  standalone: true,
  imports: [CommonModule, DocumentTableComponent],
  templateUrl: './processed.html',
  styleUrl: './processed.scss',
})
export class Processed extends Document {
  status: string = 'processed'
}